import React from 'react';
import {useWaypoints} from 'ui/Navbar/useWaypoints';
import Navbar from 'ui/Navbar/Navbar';

export default () => {
    const {links} = useWaypoints({});
    return <Navbar links={links} active={1} />;
};
